import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface Message {
  content: string | null;
  severity: "success" | "info" | "warning" | "error";
}

export interface SnackbarState {
  message: Message | null;
}

const initialState: SnackbarState = {
  message: null,
};

export const snackbarSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<Message | null>) => {
      state.message = action.payload;
    },
  },
});

export const { setMessage } = snackbarSlice.actions;

export default snackbarSlice.reducer;
